import * as React from 'react';
import {useEffect, useState} from "react";
import type { MenuData } from "../../js/data/menuData.ts";
import { fetchMenuByUrl } from "../../js/loaders.ts";
import Footer from "./footer.tsx";

type Props = {}

function FooterLoader({...otherProps}: Props) {

	const [menu, setMenu] = useState<MenuData>(null);

	useEffect(() => {
		fetchMenuByUrl('footer').then((data) => {
			setMenu(data);
		});
	}, []);

	return (<>
		<Footer
			menu={menu}
			pathname={window.location.pathname}
			{...otherProps}
		/>
	</>);
}

export default FooterLoader;
